module.exports = __webpack_public_path__ + "static/media/producers.50156418.svg";